
import {
  Vue, Component, Prop, PropSync, Watch,
} from 'vue-property-decorator';
import { debounce } from 'ts-debounce';
import { ShipTo, PredictionAddressDto } from '@/features/shipment/types';
import { getCarriersClarificationAddresses, getClarificationDetailFromMapAddress } from '../../services/shipment.services';
import { trackSelectAddressSuggestion, trackManualEntryAddress } from '../../helpers/tracked-events/google-address-integration';

@Component
export default class AddressAutocompleteLookup extends Vue {
  @Prop({ required: true }) location!: string;

  @PropSync('data', { required: true }) syncedData!: ShipTo;

  private showForm = false;

  private addressAutocomplete: {
    items: PredictionAddressDto[],
    isLoading: boolean,
    search: string,
  } = {
    items: [],
    isLoading: false,
    search: '',
  };

  @Watch('addressAutocomplete.search', { immediate: true })
  private async searchAddresses(search: string) {
    if (!search) return;
    this.debounceSearchAddresses(search);
  }

  private debounceSearchAddresses = debounce(
    this.debounceSearchAddressesHandler, 500,
  );

  private async debounceSearchAddressesHandler(value: string) {
    this.addressAutocomplete.isLoading = true;
    const items = await getCarriersClarificationAddresses(value);
    this.addressAutocomplete.isLoading = false;
    if (!items) return;

    this.addressAutocomplete.items = [...items];
  }

  private onAddAddressManually() {
    this.showForm = true;
    trackManualEntryAddress(this.$gtag);
  }

  private async onSelectAddress(address: PredictionAddressDto) {
    const { placeId } = address;

    if (!placeId) return;

    const addressDetail = await getClarificationDetailFromMapAddress(placeId);

    if (!addressDetail) return;

    const finalAddress = addressDetail
      .find((ad) => !!ad.postalCode && !!ad.countryCode) || addressDetail[0];
    if (!finalAddress) return;

    this.showForm = true;

    const {
      countryCode, postalCode, city, addr1, province,
    } = finalAddress;

    this.syncedData.countryCode = countryCode || '';
    this.syncedData.postalCode = postalCode || '';
    this.syncedData.city = city || '';
    this.syncedData.addr1 = addr1 || '';
    this.syncedData.province = province || '';
    trackSelectAddressSuggestion(this.$gtag);
  }
}
